import PropTypes from 'prop-types';

export const organizationInfoPropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  hostnamePrefix: PropTypes.string,
  status: PropTypes.string,
  customerId: PropTypes.string,
  samlEnabled: PropTypes.bool,
  isTrial: PropTypes.bool,
});

export const passwordRequiredComplexityType = PropTypes.shape({
  requiresUppercaseLetter: PropTypes.bool.isRequired,
  requiresLowercaseLetter: PropTypes.bool.isRequired,
  requiresDigit: PropTypes.bool.isRequired,
  requiresSpecialCharacter: PropTypes.bool.isRequired,
  webloginSequenceMatching: PropTypes.bool.isRequired,
  dictionaryMatching: PropTypes.bool.isRequired,
});

export const organizationPasswordRulesPropType = PropTypes.shape({
  mobilePINLockEnabled: PropTypes.bool,
  mobilePINLockTimeout: PropTypes.number,
  passwordUniqueHistory: PropTypes.number,
  passwordMinimumLength: PropTypes.number,
  passwordRequiredComplexity: PropTypes.oneOfType([
    passwordRequiredComplexityType,
    PropTypes.string,
  ]),
  passwordMaximumAge: PropTypes.number,
  passwordMinimumAge: PropTypes.number,
  passwordLockoutThreshold: PropTypes.number,
  passwordLockoutDuration: PropTypes.number,
  passwordLockoutResetPeriod: PropTypes.number,
});

export const PasswordComplexityTypes = {
  NONE: 'NONE',
  NON_ALPHA: 'NON_ALPHA',
  STRONG: 'STRONG',
};
